import _LoadingOutlined from "@zenlayer/zen-design-icons/assets/LoadingOutlined.svg";
import { Spin as AntdSpin } from 'antd';
import classNames from 'classnames';
import React from 'react';
import Icon from '../icon';
import { jsx as _jsx } from "react/jsx-runtime";
export const indicatorIcon = /*#__PURE__*/_jsx(Icon, {
  type: "LoadingOutlined",
  style: {
    fontSize: 24
  },
  spin: true
});
const Spin = props => {
  const {
    indicator,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    wrapperClassName,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-spin");
  const baseWrapperClassName = "".concat(prefixClass, "-spin-wrap");
  return /*#__PURE__*/_jsx(AntdSpin, {
    wrapperClassName: classNames(baseWrapperClassName, wrapperClassName),
    className: classNames(baseClassName, className),
    indicator: indicator || indicatorIcon,
    ...restProps
  });
};
export default Spin;